module.exports = __webpack_public_path__ + "media/images/decoration-email-image-c2055a97dc6121b373df81fe9bc9b36a.png";